export default class AddinPinModes {
    public readMode: boolean;
    public composeMode: boolean;
    public calendarMode?: boolean;
}
